<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">{{
          $t('administration.personneMorale.personneMorale.detail.title') +
            (this.nomUsuel ? ' ' + this.nomUsuel : '')
        }}</v-list-item-title>
        <v-list-item-subtitle>{{
          $t('administration.personneMorale.personneMorale.detail.sub')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text class="pt-0">
      <v-form ref="form">
        <v-row dense>
          <v-col cols="12" md="6" sm="12">
            <v-text-field
              dense
              filled
              v-model="nomUsuel"
              :label="$t('personneMorale.detail.form.nomUsuel')"
              readonly
            />
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <v-text-field
              dense
              filled
              v-model="raisonSociale"
              :label="$t('personneMorale.detail.form.raisonSociale')"
              readonly
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="2">
            <v-text-field
              dense
              filled
              v-model="id"
              :label="$t('personneMorale.detail.form.id')"
              readonly
            />
          </v-col>
          <v-col cols="12" md="4" sm="12">
            <v-checkbox
              v-model="form.organisationPro"
              :label="
                $t(
                  'administration.personneMorale.personneMorale.detail.form.organisationPro',
                )
              "
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <v-card>
              <v-card-title>
                {{
                  $tc(
                    'personneMorale.detail.form.panel.divisions.title',
                    form.divisions ? Object.keys(form.divisions).length : 0,
                  )
                }}
                <v-spacer />
                <v-btn
                  small
                  outlined
                  color="secondary"
                  @click="divisionCreer(null)"
                >
                  {{
                    $t(
                      'administration.personneMorale.personneMorale.detail.buttons.addDivision',
                    )
                  }}
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-treeview
                  :items="form.divisions"
                  item-children="subdivisions"
                  item-key="id"
                  item-text="nom"
                  hoverable
                  dense
                  open-all
                >
                  <template v-slot:append="{ item }">
                    <v-btn color="primary" icon @click="divisionModifier(item)">
                      <v-icon>mdi-pen</v-icon>
                    </v-btn>
                    <v-btn
                      color="primary"
                      icon
                      @click="divisionSupprimer(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-tooltip bottom>
                      <template #activator="data">
                        <v-btn
                          v-on="data.on"
                          color="primary"
                          icon
                          @click="divisionCreer(item)"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        $t(
                          'administration.personneMorale.personneMorale.detail.buttons.addSubdivision',
                        )
                      }}</span>
                    </v-tooltip>
                  </template>
                </v-treeview>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <v-dialog v-model="editionDialog" persistent max-width="50%">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="abortEdition()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{
            $t(
              'administration.personneMorale.personneMorale.detail.dialog.division.title',
            )
          }}</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="12">
                <v-text-field
                  filled
                  :label="
                    $t(
                      'administration.personneMorale.personneMorale.detail.dialog.division.nom',
                    )
                  "
                  v-model="divisionEditee.modifiee.nom"
                  :rules="[obligatoireRule()]"
                  hide-details="auto"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="12">
                <v-select
                  return-object
                  dense
                  filled
                  clearable
                  :items="enums.typesDivisions"
                  v-model="divisionEditee.modifiee.typeDivision"
                  item-text="libelle"
                  :label="
                    $t(
                      'administration.personneMorale.personneMorale.detail.dialog.division.typeDivision',
                    )
                  "
                  :readonly="false"
                  hide-details="auto"
                  :rules="[serveurRule('typeDivision')]"
                >
                  <template #selection="{item}">
                    {{ item.libelle }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="12">
                <v-select
                  return-object
                  dense
                  filled
                  clearable
                  :items="divisionsAPlat"
                  v-model="divisionEditee.modifiee.divisionSuperieure"
                  item-text="nom"
                  :label="
                    $t(
                      'administration.personneMorale.personneMorale.detail.dialog.division.divisionSuperieure',
                    )
                  "
                  :readonly="false"
                  hide-details="auto"
                >
                  <template #selection="{item}">
                    {{ item.nom }}
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="abortEdition">
              {{ $t('button.cancel') }}
            </v-btn>
            <v-btn text color="primary" @click="confirmEdition">
              {{ $t('button.confirm') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
    <v-card-actions>
      <v-btn text @click="quit">
        {{ $t('button.cancel') }}
      </v-btn>
      <v-btn text color="primary" @click="save">
        {{ $t('button.save') }}
      </v-btn>

      <v-dialog v-model="suppressionDialog" persistent max-width="50%">
        <v-card>
          <v-card-title class="accent white--text">
            <v-icon color="white">mdi-alert</v-icon> Suppression de division
          </v-card-title>
          <v-card-text class="body-1">
            <p class="pt-4">
              Vous vous apprêtez à supprimer la division. Toutes ses
              subdivisions seront rattachées à sa division parente.
            </p>
            <p>
              Êtes-vous sûr de vouloir continuer ?
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="confirmSuppression()">
              {{ $t('button.yes') }}
            </v-btn>
            <v-btn text @click="abortSuppression()">
              {{ $t('button.no') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="control.confirmQuit" persistent max-width="50%">
        <v-card>
          <v-card-title class="accent white--text">
            <v-icon color="white">mdi-alert</v-icon> Édition en cours
          </v-card-title>
          <v-card-text class="body-1">
            <p class="pt-4">
              Vous allez quitter la page actuelle et perdre toutes les
              modifications non sauvegardées.
            </p>
            <p>
              Êtes-vous sûr de vouloir continuer ?
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="control.onConfirmQuit">
              {{ $t('button.yes') }}
            </v-btn>
            <v-btn text @click="abortQuit()">
              {{ $t('button.no') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="control.confirmError" persistent max-width="50%">
        <v-card>
          <v-card-title class="error white--text">
            <v-icon color="white">mdi-alert</v-icon
            >{{ this.control.error.title }}
          </v-card-title>
          <v-card-text class="body-1">
            <p class="pt-4">
              {{ this.control.error.message }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="confirmError()">
              {{ $t('button.ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import ValidationRules from '@/plugins/mixins/ValidationRules';
import ServeurRule from '@/plugins/mixins/ServeurRule';
import toasted from '@/utils/toasted';
import _ from 'lodash';

export default {
  mixins: [ValidationRules, ServeurRule],
  props: {
    /** Titre de la page */
    title: {
      type: String,
      default: null,
    },
    /** Les infos pour le retour vers le menu paramétrage */
    returnRoute: {},
    /*
    id: {
      type: String,
      default: null,
    },
    */
  },

  data() {
    return {
      // Les enums
      enums: {
        typesDivisions: [],
      },

      // Infos affichées readonly
      id: null,
      nomUsuel: '',
      raisonSociale: '',

      // Le formulaire à renvoyer au Back
      form: {
        organisationPro: false,
        // Collections
        divisions: [],
      },
      divisionsAPlat: [],
      divisionsMap: [],

      // Créer / modifier une division
      editionDialog: false,
      // Supprimer une division
      suppressionDialog: false,
      divisionEditee: {
        modeEdition: null,
        ref: null,
        modifiee: {
          id: null,
          nom: null,
          typeDivision: null,
          divisionSuperieure: null,
        },
      },

      // ID provisoire pour les
      nextId: -1,

      // Pour éviter de quitter intempestivement
      control: {
        modeCreation: false,
        initial: null,
        confirmQuit: false,
        onConfirmQuit: null,
        confirmRemove: false,
        confirmError: false,
        error: {
          title: '',
          message: '',
        },
      },
    };
  },
  created() {
    this.initEnums();
  },
  mounted() {
    this.load();
  },
  watch: {
    $route() {
      this.load();
    },
  },
  beforeRouteLeave(to, from, next) {
    // Pour éviter de quiter intempestivement
    if (!_.isEqual(this.form, this.control.initial)) {
      this.control.confirmQuit = true;
      this.control.onConfirmQuit = next;
    } else {
      next();
    }
  },
  methods: {
    load() {
      if (this.$route && this.$route.params && this.$route.params.id) {
        this.id = this.$route.params.id;
      }
      this.loadEntity(this.id);
    },
    // Init en cas de modification
    loadEntity(id) {
      this.$api('administration/personne-morale/personne-morale/' + id)
        .get()
        .then(response => {
          this.initForm(response.body);
        });
    },
    // Init en cas de création
    loadNew() {
      this.initForm({});
    },
    initForm(loaded) {
      this.nomUsuel = loaded.nomUsuel;
      this.raisonSociale = loaded.raisonSociale;
      this.form.organisationPro = loaded.organisationPro || false;

      // Collections
      this.form.divisions = loaded.divisions || [];
      this.divisionsMap = new Map();
      this.divisionsToMap(this.form.divisions);

      this.control.initial = JSON.parse(JSON.stringify(this.form));
    },
    // Chargement des listes d'enums depuis le Back
    initEnums() {
      this.$api('administration/personne-morale/personne-morale-enum')
        .get()
        .then(response => {
          const body = response.body;
          const enums = this.enums;
          enums.typesDivisions = body.typesDivisions;
        });
    },
    // Met à jour la Map des divisions à plat
    divisionsToMap(newValues) {
      if (Array.isArray(newValues) && newValues.length > 0) {
        newValues.forEach(division => {
          this.divisionsMap.set(division.id, division);
          this.divisionsToMap(division.subdivisions);
        });
      }
    },

    // Modification de division (ouverture de la popup)
    divisionModifier(item) {
      this.divisionToForm(item, 'modification');
      this.editionDialog = true;
    },
    // Création de division (ouverture de la popup)
    divisionCreer(parent) {
      let item = Object.assign({}, this.divisionEditee);
      item.divisionSuperieure = parent;
      this.divisionToForm(item, 'creation');
      this.editionDialog = true;
    },
    // On prépare les données pour l'affichage de la division dans la dialog
    divisionToForm(division, mode) {
      this.divisionEditee.modeEdition = mode;
      this.divisionEditee.ref = division;
      this.divisionEditee.modifiee.id = division.id;
      this.divisionEditee.modifiee.nom = division.nom;
      this.divisionEditee.modifiee.typeDivision = division.typeDivision;
      this.divisionEditee.modifiee.divisionSuperieure =
        division.divisionSuperieure;
      this.divisionsAPlat = this.divisionsToArray(
        [],
        this.form.divisions,
        division.id,
      );
    },
    // Met à jour le tableau des divisions à plat
    divisionsToArray(currentValues, newValues, excludedId) {
      if (Array.isArray(newValues) && newValues.length > 0) {
        newValues.forEach(division => {
          if (division.id != excludedId) {
            // Une division ne peut pas être placée dans elle même ni une de ses subdivisions
            currentValues.push({ id: division.id, nom: division.nom });
            this.divisionsToArray(
              currentValues,
              division.subdivisions,
              excludedId,
            );
          }
        });
      }
      return currentValues;
    },
    // Préparation de la suppression
    divisionSupprimer(item) {
      this.divisionToForm(item, 'suppression');
      this.suppressionDialog = true;
    },

    // Annulation de modification ou création de division (à la fermeture de la popup)
    abortEdition() {
      this.resetEdition();
      this.editionDialog = false;
    },
    // Confirmation de modification ou création de division (à la fermeture de la popup)
    confirmEdition() {
      if (this.divisionEditee.modeEdition === 'modification') {
        this.confirmModification();
      } else if (this.divisionEditee.modeEdition === 'creation') {
        this.confirmCreation();
      }
      this.resetEdition();
      this.divisionsMap = new Map();
      this.divisionsToMap(this.form.divisions);
      this.editionDialog = false;
    },
    // Traitement de création de division
    confirmCreation() {
      let nouvelleDivision = {};
      nouvelleDivision.id = this.getNextId();
      nouvelleDivision.nom = this.divisionEditee.modifiee.nom;
      nouvelleDivision.typeDivision = this.divisionEditee.modifiee.typeDivision;
      nouvelleDivision.subdivisions = [];
      nouvelleDivision.divisionSuperieure = this.divisionEditee.modifiee.divisionSuperieure;
      this.moveDivisionToNewParent(nouvelleDivision, null);
    },
    // Traitement de modification de division
    confirmModification() {
      if (this.divisionEditee.ref.id == this.divisionEditee.modifiee.id) {
        // En principe, ce test est inutile. Mais sait-on jamais
        this.divisionEditee.ref.nom = this.divisionEditee.modifiee.nom;
        this.divisionEditee.ref.typeDivision = this.divisionEditee.modifiee.typeDivision;
        if (this.divisionEditee.modifiee.divisionSuperieure != null) {
          if (this.divisionEditee.ref.divisionSuperieure == null) {
            // Il n'y avait pas de division parente et on en ajoute une
            this.divisionEditee.ref.divisionSuperieure = this.divisionEditee.modifiee.divisionSuperieure;
            this.moveDivisionToNewParent(this.divisionEditee.ref, null);
          } else {
            // Il y avait une division parente et on la change
            let idParent = this.divisionEditee.ref.divisionSuperieure.id;
            this.divisionEditee.ref.divisionSuperieure = this.divisionEditee.modifiee.divisionSuperieure;
            this.moveDivisionToNewParent(this.divisionEditee.ref, idParent);
          }
        } else {
          // Il y avait une division parente et on la supprime
          if (this.divisionEditee.ref.divisionSuperieure != null) {
            let idParent = this.divisionEditee.ref.divisionSuperieure.id;
            this.divisionEditee.ref.divisionSuperieure = null;
            this.moveDivisionToNewParent(this.divisionEditee.ref, idParent);
          }
        }
      }
    },
    // Gère l'ajout d'une division dans l'arbre this.divisions
    addDivisionToParent(division) {
      if (division.divisionSuperieure) {
        let parent = this.divisionsMap.get(division.divisionSuperieure.id);
        parent.subdivisions.push(division);
        division.niveau = parent.niveau + 1;
      } else {
        this.form.divisions.push(division);
        division.niveau = 1;
      }
    },
    // Gère le déplacement d'une division dans l'arbre this.divisions
    moveDivisionToNewParent(division, idOldParent) {
      let index = -1;
      var i = 0;
      if (idOldParent) {
        let oldParent = this.divisionsMap.get(idOldParent);
        for (i = 0; i < oldParent.subdivisions.length && index < 0; i++) {
          if (oldParent.subdivisions[i].id == division.id) {
            index = i;
          }
        }
        if (index >= 0) {
          // On retire la division de son ancien parent
          oldParent.subdivisions.splice(index, 1);
        }
      } else {
        for (i = 0; i < this.form.divisions.length && index < 0; i++) {
          if (this.form.divisions[i].id == division.id) {
            index = i;
          }
        }
        if (index >= 0) {
          // On retire la division de la racine
          this.form.divisions.splice(index, 1);
        }
      }
      this.addDivisionToParent(division);
    },
    // Annulation de la suppression
    abortSuppression() {
      this.resetEdition();
      this.suppressionDialog = false;
    },
    // Traitement de suppression de division
    confirmSuppression() {
      // On supprime la division, et ses subdivisions
      let idParent = null;
      if (this.divisionEditee.ref.divisionSuperieure != null) {
        idParent = this.divisionEditee.ref.divisionSuperieure.id;
      }
      let parent = this.divisionsMap.get(idParent);
      let division = this.divisionsMap.get(this.divisionEditee.ref.id);

      // On supprime la division
      let index = -1;
      var i = 0;
      if (parent != null) {
        for (i = 0; i < parent.subdivisions.length && index < 0; i++) {
          if (parent.subdivisions[i].id == division.id) {
            index = i;
          }
        }
        if (index >= 0) {
          // On retire la division de son ancien parent
          parent.subdivisions.splice(index, 1);
        }
      } else {
        for (i = 0; i < this.form.divisions.length && index < 0; i++) {
          if (this.form.divisions[i].id == division.id) {
            index = i;
          }
        }
        if (index >= 0) {
          // On retire la division de la racine
          this.form.divisions.splice(index, 1);
        }
      }

      this.resetEdition();
      this.divisionsMap = new Map();
      this.divisionsToMap(this.form.divisions);
      this.suppressionDialog = false;
    },
    // ID négatifs pour la création
    getNextId() {
      const nextId = this.nextId;
      this.nextId--;
      return nextId;
    },
    // On reset la division éditée
    resetEdition() {
      this.divisionEditee.modeEdition = null;
      this.divisionEditee.ref = null;
      this.divisionEditee.modifiee.id = null;
      this.divisionEditee.modifiee.nom = null;
      this.divisionEditee.modifiee.typeDivision = null;
      this.divisionEditee.modifiee.divisionSuperieure = null;
      this.divisionsAPlat = [];
    },

    /**
     * Sauvegarde
     */
    getForms() {
      //access aux formulaire à créer
      return [this.$refs.form];
    },

    // Save
    save() {
      this.doSave();
    },
    doSave() {
      const ok = this.getForms()
        .map(f => f.validate())
        .every(v => !!v);
      if (ok) {
        if (this.id) {
          this.doUpdate();
        }
      }
    },
    doUpdate() {
      this.$api('administration/personne-morale/personne-morale/' + this.id)
        .post(this.form)
        .then(
          response => {
            this.initForm(response.body);
            toasted.info('form.saved');
            this.doQuit();
          },
          () => {
            toasted.error('form.error');
          },
        );
    },

    confirmError() {
      this.control.confirmError = false;
    },

    // Cancel
    quit() {
      if (!_.isEqual(this.form, this.control.initial)) {
        this.control.confirmQuit = true;
        this.control.onConfirmQuit = this.doQuit;
      } else {
        this.doQuit();
      }
    },
    abortQuit() {
      this.control.confirmQuit = false;
    },

    // Quit
    doQuit() {
      this.$router.replace(this.returnRoute);
    },
  },
};
</script>
